import styled from "@emotion/styled";
import { Container } from "@mui/material";

export const StyledHeaderContainer = styled(Container)(({ theme, cssProps }) => ({
  padding: "0rem !important",
  margin: "1rem 0rem",
  ...(cssProps || {}),
}));
